import { isGlobalFeatureEnabled } from "owa-feature-flags";

// This function gives back the minimum width of the "content" of the canvas,
// These are determined by designers, and is approximately 380px for the content.
// The numbers are slightly higher in the end due to padding/margin considerations.
export function getCanvasContentMinimumWidth(): number {
    const MINIMUM_CANVAS_CONTENT_WIDTH = 435;
    const MINIMUM_CANVAS_CONTENT_WIDTH_DENSELESS = 398;
    return isGlobalFeatureEnabled("rp-denseless")
        ? MINIMUM_CANVAS_CONTENT_WIDTH_DENSELESS
        : MINIMUM_CANVAS_CONTENT_WIDTH;
}
